import { IMG, SERVICES } from "../data/site";
import { PageHero, Section, Overline, Btn, IconTile } from "../components/site/bits";
import { Reveal, Stagger } from "../components/site/motion";

export default function Services() {
  return (
    <>
      <PageHero overline="Support Services" lines={["Support for every", "step of the journey."]} image={IMG.esol}
        intro="From the day someone arrives to the day they move on, our team provides practical, personalised support across every part of life in the UK." />

      <Section>
        <Stagger className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <IconTile key={s.title} icon={s.icon} title={s.title} desc={s.desc} index={String(i + 1).padStart(2, "0")} />
          ))}
        </Stagger>
      </Section>

      <Section className="bg-brand-dark text-brand-main">
        <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-6">
            <Overline className="text-brand-leaf">Our approach</Overline>
            <Reveal><h2 className="mt-6 font-serif text-4xl tracking-tight md:text-5xl">A plan built around the person.</h2></Reveal>
            <Reveal delay={0.1}><p className="mt-6 text-lg text-brand-main/75">No two journeys are the same. Every resident works with a dedicated support worker to build a personalised plan — with clear goals across housing, finances, learning, work and wellbeing.</p></Reveal>
            <div className="mt-8"><Btn to="/contact" variant="light" testid="services-contact-btn">Talk to our team</Btn></div>
          </div>
          <div className="lg:col-span-6"><div className="overflow-hidden rounded-2xl"><img src={IMG.office} alt="One-to-one support" className="h-96 w-full object-cover" /></div></div>
        </div>
      </Section>
    </>
  );
}
